import React, { useState, useEffect } from 'react';
import logo from './../../assets/images/logo.jpg';
import { getCurrentUser } from 'aws-amplify/auth';
import { logout } from './../../libs/auth';

function Header() {
	const [isAuthenticated, setIsAuthenticated] = useState(false);

	useEffect(() => {
		async function checkAuth() {
			try {
				await getCurrentUser();
				setIsAuthenticated(true);
			} catch (e) {
				setIsAuthenticated(false);
			}
		}
		checkAuth();
	}, []);

	const handleLogout = async (e) => {
		e.preventDefault();
		await logout();
	}

	return (
		<header>
			<div className='header__logo--container'>
				<img hidden={isAuthenticated ? "hidden" : ""} src={logo} alt="Medicaid Clinic Logo" />
			</div>
			<div className="header__logout--container">
				{isAuthenticated && (
					<a href="#" className="logout-link" onClick={handleLogout}>Logout</a>
				)}
			</div>
		</header>
	);
}

export default Header;